import { EmbeddedMapTileSwiperProvider } from 'components/map/map-controller/tiles/shared/simpleTile-click-context';
import { PageNavigationHook } from 'components/tracking/page-navigation-hook';
import { ErrorPage } from 'layout/error-page';
import { createBrowserRouter } from 'react-router-dom';
import { MainJsonV2 } from 'routing/main-2-json-v2';
import { PageChangeProvider } from 'utilities/hooks/page-change-provider';

/**
 * Exported router to allow use of router.navigate outside of react lifecycle
 * https://github.com/remix-run/react-router/issues/7634#issuecomment-1306650156
 */
export const router = createBrowserRouter([
  {
    path: '/*',
    element: (
      <EmbeddedMapTileSwiperProvider>
        <PageChangeProvider>
          <PageNavigationHook>
            <MainJsonV2 />
          </PageNavigationHook>
        </PageChangeProvider>
      </EmbeddedMapTileSwiperProvider>
    ),
    errorElement: <ErrorPage />,
  },
]);
